/**
 * 店鋪／商家圖示
 * 使用 lucide-react Store，意象：店家、商店
 * 用於 LITE 商家註冊、建立商家等入口，可加藍邊
 */

import { Store } from 'lucide-react';

interface StorefrontIconProps {
  /** 尺寸 class，如 'w-16 h-16'、'w-14 h-14' */
  className?: string;
  /** 是否顯示藍邊（外框），預設 true */
  withBorder?: boolean;
}

export function StorefrontIcon({
  className = 'w-16 h-16',
  withBorder = true,
}: StorefrontIconProps) {
  const icon = <Store className={className} aria-hidden />;

  if (withBorder) {
    return (
      <div className="inline-flex items-center justify-center rounded-lg border-2 border-blue-500 p-2 text-blue-600">
        {icon}
      </div>
    );
  }
  return icon;
}
